import { defineStore } from "pinia";

import { ref } from 'vue';

const lightboxContent = ref(null);

export const useLightboxStore = defineStore("lightbox", {
  state: () => {
    return {
      
      isActive: false,
      htmlContent: null,
      gallerySlides: [],
      refs: {}
      
    };
  },
  actions: {

    open(description, gallery) {
      this.htmlContent = description;
      if (typeof gallery !== 'undefined') this.gallerySlides = gallery;
      else this.gallerySlides = [];
      this.isActive = true;
      this.refs.lightboxContent.focus();
      return false
    },

    close(e) {
      this.isActive = false;
      return false
    }
    
  },
  getters: {
    
  },
});